import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

type AuthState = {
    needsVerification: boolean;
};
const initialState: AuthState = {
    needsVerification: false,
};

const authenticationSlice = createSlice({
    name: "authentication",
    initialState,
    reducers: {
        setNeedsVerification: function (
            state: AuthState,
            action: PayloadAction<{ needsVerification: boolean }>,
        ) {
            state["needsVerification"] = action.payload.needsVerification;
        },
    },
});

export function getNeedsVerification() {
    return (state: { authentication: AuthState }) =>
        state.authentication.needsVerification;
}

export function useUserVerification(): [boolean, (value: boolean) => void] {
    const dispatch = useDispatch();

    const needsVerification = useSelector(getNeedsVerification());

    const setVerification = (value: boolean) => {
        dispatch(setNeedsVerification({ needsVerification: value }));
    };

    return [needsVerification, setVerification];
}

export const { setNeedsVerification } = authenticationSlice.actions;

export default authenticationSlice.reducer;
